import cx from "classnames";
import dynamic from "next/dynamic";
import withLoadingProps from "next-dynamic-loading-props";

import styles from "./styles.module.css";

// AVAIALABLE ILLUSTRATIONS
export const illustrationSizes: Record<
  string,
  { width: number; height: number }
> = {
  // OLD
  confused: {
    width: 502,
    height: 427,
  },
  confusedGrey: {
    width: 502,
    height: 427,
  },
  person: {
    width: 641,
    height: 287,
  },
  personGrey: {
    width: 641,
    height: 287,
  },
  vines: {
    width: 260,
    height: 238,
  },
  world: {
    width: 504,
    height: 418,
  },
  worldGreenBg: {
    width: 504,
    height: 418,
  },
  // NEW
  container: {
    width: 548,
    height: 492,
  },

  containerDark: {
    width: 548,
    height: 492,
  },
  delivery: {
    width: 549,
    height: 543,
  },
  deliveryDark: {
    width: 549,
    height: 543,
  },
  flowerQr: {
    width: 531,
    height: 534,
  },
  flowerQrDark: {
    width: 531,
    height: 534,
  },
  laundry: {
    width: 547,
    height: 568,
  },
  laundryDark: {
    width: 547,
    height: 568,
  },
  windowLaptop: {
    width: 565,
    height: 557,
  },
  windowLaptopDark: {
    width: 565,
    height: 557,
  },
} as const;

export type IllustrationType = keyof typeof illustrationSizes;

export type IllustrationProps = {
  type: IllustrationType;
  title?: string;
  className?: string;
  illustrationClassName?: string;
  illustrationStyle?: Record<string, unknown>;
};

export const IllustrationPlaceholder = ({
  type,
  title,
  illustrationClassName,
  illustrationStyle = {},
}: IllustrationProps) => {
  const { width, height } = illustrationSizes[type];
  return (
    <svg
      className={illustrationClassName}
      style={illustrationStyle}
      aria-label={title}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    />
  );
};

const IllustrationLoader = withLoadingProps<IllustrationProps>(
  (useLoadingProps) =>
    dynamic(() => import("./IllustrationFull"), {
      loading: () => {
        const props = useLoadingProps() as IllustrationProps;
        return <IllustrationPlaceholder {...props} />;
      },
    })
);

export const Illustration = (props: IllustrationProps) => {
  return (
    <figure className={cx(styles.container, props.className)}>
      <IllustrationLoader {...props} />
    </figure>
  );
};
